export default "__VITE_PUBLIC_ASSET__874bbfdb__"